import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import { NutritionFacadeService } from '@emm/management/services/nutrition-facade.service';
import {LocationSetsFacadeService} from '@emm/management/services/location-sets-facade.service';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-nutrition-assignments-location-sets',
    styleUrls: ['./nutrition-assignments-location-sets.component.scss'],
    templateUrl: './nutrition-assignments-location-sets.component.html',
    standalone: false
})
export class NutritionAssignmentsLocationSetsComponent implements OnInit {

    nodes$ = this.locationSetsFacade.locationSetsAsNodes$;

    constructor(
        private locationSetsFacade: LocationSetsFacadeService,
        private nutritionFacade: NutritionFacadeService
    ) {}
    ngOnInit(): void {
        this.nutritionFacade.locationSetType$.subscribe(setType => {
            setTimeout(() => this.locationSetsFacade.selectLocationSetType(setType), 0);
        });
    }


}
